module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("“Consider well. He is a Prince!”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("“More! He is a Man!”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Zauberflöte")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3682b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epi.vue
// module id = 66
// module chunks = 0